import { GENERATE_POSTS_COMBINED } from "../configs/routes.js";
import api from "./api.js";

export const generatePostsCombined = (payload) =>
    new Promise((resolve, reject) => {
        api
            .post(GENERATE_POSTS_COMBINED, payload, { timeout: 120000 })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });
